//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: '',
  props: {
    navbarColor: {
      type: String,
      required: true
    },
    menuColor: {
      type: String,
      required: true
    },
    btnColor: {
      type: String,
      required: true
    }
  },
  data () {
    return {

    }
  },
  components: {

  }
}



// WEBPACK FOOTER //
// ./src/views/layout/components/RightLayer/ThemePicker/themeItem.vue